import React from 'react';
import { Select } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useCurrentSession } from '@/hooks/useCurrentSession';

export const SessionSelector: React.FC = () => {
  const { currentSessionId, sessions, isLoading, selectSession } = useCurrentSession();
  
  if (isLoading || sessions.length === 0) {
    return null;
  }
  
  const options = sessions.map(session => ({
    value: session.intake_portal_session_id.toString(),
    label: session.title || `Session ${session.intake_portal_session_id}`,
  }));
  
  return (
    <Select
      value={currentSessionId?.toString() || ''}
      onChange={(value) => {
        if (value) {
          selectSession(parseInt(value, 10));
        }
      }}
      data={options}
      placeholder="Search sessions..."
      searchable
      leftSection={<IconSearch size={16} />}
      size="sm"
      styles={{
        input: { minWidth: 300, maxWidth: 400 },
      }}
    />
  );
};